export default __webpack_public_path__ + "static/media/kit.0553de48.png";